/**
 * 数値を "¥1,234" 形式の円表示にフォーマットする。
 *
 * @param value フォーマット対象の数値
 * @returns "¥" プレフィクスを付けた日本円表示文字列
 */
export const formatJPY = (value: number): string =>
  `¥${value.toLocaleString()}`;
